/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M3.00024 19.0002H7.00024M3.00024 3.00018H21.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3 11L18 11C20.2091 11 22 12.7909 22 15V15C22 17.2091 20.2091 19 18 19L12 19M12 19L15 16M12 19L15 22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M3.00024 19.0002H7.00024M3.00024 11.0002L18.0002 11.0002C20.2094 11.0002 22.0002 12.791 22.0002 15.0002V15.0002C22.0002 17.2093 20.2094 19.0002 18.0002 19.0002L12.0002 19.0002M12.0002 19.0002L15.0002 16.0002M12.0002 19.0002L15.0002 22.0002M3.00024 3.00018H21.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M3 19H7M3 11L18 11C20.2091 11 22 12.7909 22 15V15C22 17.2091 20.2091 19 18 19L12 19M12 19L15 16M12 19L15 22M3 3H21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M3.00024 19.0002H7.00024M3.00024 11.0002L18.0002 11.0002C20.2094 11.0002 22.0002 12.791 22.0002 15.0002V15.0002C22.0002 17.2093 20.2094 19.0002 18.0002 19.0002L12.0002 19.0002M12.0002 19.0002L15.0002 16.0002M12.0002 19.0002L15.0002 22.0002M3.00024 3.00018H13.0002M17.0002 3.00018H21.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3.00024 19.0002H7.00024M3.00024 11.0002L18.0002 11.0002C20.2094 11.0002 22.0002 12.791 22.0002 15.0002V15.0002C22.0002 17.2093 20.2094 19.0002 18.0002 19.0002L12.0002 19.0002M12.0002 19.0002L15.0002 16.0002M12.0002 19.0002L15.0002 22.0002M3.00024 3.00018H21.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M3 19H7M3 11L18 11C20.2091 11 22 12.7909 22 15V15C22 17.2091 20.2091 19 18 19L12 19M12 19L15 16M12 19L15 22M3 3H21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
